export default {
  locale: "es",
  BModal: {
    cancelTitle: "Cancelar",
    okTitle: "Aceptar",
    headerCloseContent: "&times;",
    headerCloseLabel: "Cerrar",
  },
  BFormDatepicker: {
    locale: "es",
    labelCalendar: "Calendario",
    labelCurrentMonth: "Mes actual",
    labelHelp: "Usa las teclas de cursor para navegar por las fechas del calendario",
    labelNav: "Navegación del calendario",
    labelNextDecade: "Sig. década",
    labelNextMonth: "Siguiente mes",
    labelNextYear: "Siguiente año",
    labelNoDateSelected: "Sin fecha seleccionada",
    labelPrevDecade: "Década anterior",
    labelPrevMonth: "Mes anterior",
    labelPrevYear: "Año anterior",
    labelSelected: "Fecha seleccionada",
    labelToday: "Hoy",
  },
};
